import { render, staticRenderFns } from "./PersonalizedDialog.vue?vue&type=template&id=f93cdefa"
import script from "./PersonalizedDialog.vue?vue&type=script&lang=js"
export * from "./PersonalizedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports